var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2667 3.23333C13.8 2.76667 13.1667 2.5 12.5 2.5C11.8333 2.5 11.2 2.76667 10.7333 3.23333C10.2667 3.7 10 4.33333 10 5C10 5.66667 10.2667 6.3 10.7333 6.76667C11.2 7.23333 11.8333 7.5 12.5 7.5C13.1667 7.5 13.8 7.23333 14.2667 6.76667C14.7333 6.3 15 5.66667 15 5C15 4.33333 14.7333 3.7 14.2667 3.23333ZM5.83333 0V10H19.1667V0H5.83333ZM17.5 6.66667C17.0583 6.66667 16.6333 6.84167 16.325 7.15833C16.0083 7.46667 15.8333 7.89167 15.8333 8.33333H9.16667C9.16667 7.89167 8.99167 7.46667 8.675 7.15833C8.36667 6.84167 7.94167 6.66667 7.5 6.66667V3.33333C7.94167 3.33333 8.36667 3.15833 8.675 2.84167C8.99167 2.53333 9.16667 2.10833 9.16667 1.66667H15.8333C15.8333 2.10833 16.0083 2.53333 16.325 2.84167C16.6333 3.15833 17.0583 3.33333 17.5 3.33333V6.66667ZM4.16667 1.66667H2.5C2.04167 1.66667 1.66667 1.29167 1.66667 0.833333C1.66667 0.375 2.04167 0 2.5 0H4.16667V1.66667ZM4.16667 5.83333H1.66667C1.20833 5.83333 0.833333 5.45833 0.833333 5C0.833333 4.54167 1.20833 4.16667 1.66667 4.16667H4.16667V5.83333ZM4.16667 10H0.833333C0.373333 10 0 9.625 0 9.16667C0 8.70833 0.373333 8.33333 0.833333 8.33333H4.16667V10Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileClaim);
export default __webpack_public_path__ + "static/media/file-claim.aec3725c6373ac1e4f75bd267aa85b9a.svg";
export { ForwardRef as ReactComponent };